var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _c(
        "carousel",
        {
          attrs: {
            adjustableHeight: true,
            "per-page": 1,
            "navigation-enabled": true,
            "pagination-enabled": false,
            "navigation-next-label": "<div></div>",
            "navigation-prev-label": "<div></div>"
          },
          on: { "navigation-click-forward": _vm.onPaginationClick },
          model: {
            value: _vm.page,
            callback: function($$v) {
              _vm.page = $$v
            },
            expression: "page"
          }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      !_vm.hideNumber
        ? _c("div", { staticClass: "number" }, [
            _c("h1", [_vm._v(_vm._s(_vm.pad2(_vm.page + 1)))]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.pad2(_vm.max)))]),
            _vm._v(" "),
            _c("div", { staticClass: "line" })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-512df36c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-512df36c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/CarouselOne.vue
// module id = null
// module chunks = 